import {Component, Input} from '@angular/core';
import {DomSanitizer} from '@angular/platform-browser';

import {GetRegion2Css, GetRegion2Name} from '../../defines/client.const';
import {YoutubeService} from '../../services/youtube/youtube.service';
import {VideoHistoryService} from '../../services/video/video-history.service';
import {VideoBoxComponent} from './video-box.component';

@Component({
  selector: 'app-video-box-main',
  templateUrl: './video-box-main.component.html',
})
export class VideoBoxMainComponent extends VideoBoxComponent {
  protected readonly GetRegion2Css = GetRegion2Css;
  protected readonly GetRegion2Name = GetRegion2Name;

  constructor(
    protected sanitizer: DomSanitizer,
    protected youtube: YoutubeService,
    protected historySvc: VideoHistoryService,
  ) {
    super(sanitizer, youtube, historySvc);
  }

}
